export const AppsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      className="icon"
      aria-hidden="true"
      focusable="false"
    >
      <rect
        x="2"
        y="2"
        width="20"
        height="20"
        rx="2.5"
        fill="#40D6C3"
        stroke="white"
        strokeWidth="3"
      />
      <rect
        x="2"
        y="22"
        width="20"
        height="20"
        rx="2.5"
        fill="#FC7D43"
        stroke="white"
        strokeWidth="3"
      />
      <rect
        x="22"
        y="2"
        width="20"
        height="20"
        rx="2.5"
        fill="#D6ACFD"
        stroke="white"
        strokeWidth="3"
      />
      <rect
        x="22"
        y="22"
        width="20"
        height="20"
        rx="2.5"
        fill="#7FC8FC"
        stroke="white"
        strokeWidth="3"
      />
    </svg>
  );
};
